import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';

import { RootState } from '../../models/RootState';
import './SportsProviderIframe.scss';
import LoadingPage from '../../pages/LoadingPage/LoadingPage';
import API_V2 from '../../api-services/svls-api';
import { getBaseUrl } from '../../api-services/environment-url/environment-url';

type StoreProps = {
  gameUrl: string;
  loggedIn: boolean;
  prefersDark: string;
};

type RouteParams = {
  gamePath: string;
};

const HOST_URL = getBaseUrl(process.env.REACT_APP_NODE_ENV, 'REACT_APP_HOST_URL')

const SportsProviderIframe: React.FC<StoreProps> = (props) => {
  const { prefersDark } = props;
  const [gameSrc, setGameSrc] = useState<string>('');
  const [url, setUrl] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const { loggedIn } = props;

  const { gamePath } = useParams<RouteParams>();
  const history = useHistory();

  const getGameUrl = async () => {
    if (loggedIn) {
      setLoading(true);
      const claims = sessionStorage.getItem('jwt_token').split('.')[1];
      const userStatus = JSON.parse(window.atob(claims)).sts;

      if (userStatus === 0 || userStatus === 3) {
        return history.push(`/home`);
      }
      let response;
      try {
        const reqBody = 'desktop';
        response = await API_V2.get(
          `/catalog/v2/sports-book/lobby-urls/${reqBody}`,
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
            },
          }
        );
        console.log(response);
      } catch (e) {
        console.log(e);
      }
      if (response) {
        if (response.data.url) {
          const sportsBookUrl = `${response.data.url}&callBackUrl=${HOST_URL}/exchange_sports/inplay&primary=ffc019`;
          setGameSrc(sportsBookUrl);
        }
        setLoading(false);
      }
      setLoading(false);
    } else {
      history.push(`/`);
    }
  };

  useEffect(() => {
    getGameUrl();
  }, []);

  useEffect(() => {
    document.getElementsByClassName('router-ctn')[0].scrollIntoView();
  }, []);

  return (
    <div className="ps-iframe-ctn">
      {loading ? (
        <LoadingPage />
      ) : (
        <iframe
          src={gameSrc}
          title="Sports Book"
          allowFullScreen
          sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
        ></iframe>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    prefersDark: state.common.prefersDark,
  };
};

export default connect(mapStateToProps)(SportsProviderIframe);
